import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownWall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowDownWall"><Path d="M4.5 3.5H19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 20V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7 15.5L12 20.5L17 15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowDownWall;
